export default "__VITE_ASSET__BLkQ9t7j__"